export const AcceptIcon = () => (
  <svg x="0px" y="0px" viewBox="0 0 24 24">
    <g>
      <path d="M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z" />
    </g>
  </svg>
);
